import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import Select from '../../Components/Select/Select';
import { ISlotList } from './ISlot';
import { AutocompleteOption } from '../../Components/Select/ISelectProps';
import * as Yup from 'yup';
import {
  addSlot,
  clearAddSlotState,
} from '../../Redux/Slicers/Slot/AddSlotSlicer';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import {
  clearUpdateSlotState,
  updateSlot,
} from '../../Redux/Slicers/Slot/UpdateSlotSlicer';
import { Autocomplete, SvgIcon } from '@mui/material';
import { useLocation } from 'react-router-dom';
import UploadButtonField from '../../Components/Button/UploadButtonField';
import { Upload } from '@mui/icons-material';
import {
  clearUpdateFixtureState,
  updateFixture,
} from '../../Redux/Slicers/Fixtures/UpdateFixtureSlicer';
import {
  addFixture,
  clearAddFixtureState,
} from '../../Redux/Slicers/Fixtures/AddFixtureSlicer';

interface FixtureFormProps {
  masterForm: (data: FormikProps<any>) => void;
}

const SlotForm: FunctionComponent<FixtureFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { fixupdateableDate } = useAppSelector((state) => state.UpdateFixture);
  const { data: Fixture } = useAppSelector((state) => state?.Fixture);
  const { pathname } = location;
  const pathnameParts = location.pathname.split('/');
  const id = pathnameParts[pathnameParts.length - 1];
  const masterFrom = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      fixture_id: Yup.string().required('Please enter valid fixture_id'),
      fixture_ip_address: Yup.string().required(
        'Please enter valid fixture_ip_address'
      ),
      // location_id: Yup.string().required('Please enter location_id'),
    }),
    onSubmit: (value) => {
      if (fixupdateableDate && Object.keys(fixupdateableDate).length !== 0) {
        dispatch(
          updateFixture({
            location_id: id,
            ...value,
            id: fixupdateableDate._id,
          })
        );
      } else {
        const levelID = localStorage.getItem('level');
        dispatch(addFixture({ location_id: id, level_id: levelID, ...value }));
      }
    },
  });

  useEffect(() => {
    props.masterForm(masterFrom);
    if (fixupdateableDate) {
      masterFrom.setFieldValue('fixture_id', fixupdateableDate.fixture_id);
      masterFrom.setFieldValue('location_id', id);
      masterFrom.setFieldValue('level_id', fixupdateableDate.level_id);
      masterFrom.setFieldValue(
        'fixture_ip_address',
        fixupdateableDate.fixture_ip_address
      );
      masterFrom.setFieldValue('aisle_id', fixupdateableDate.aisle_id || '1');
      masterFrom.setFieldValue('group_id', fixupdateableDate.group_id || '1');
    }
    return () => {
      dispatch(clearAddFixtureState());
      dispatch(clearUpdateFixtureState());
      masterFrom.resetForm();
    };
  }, [fixupdateableDate]);

  const data1 = Fixture?.response?.data;
  if (!data1) {
    console.log('datanot found');
  }

  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.name,
        value: project._id!,
      }))
    : [];

  return (
    <form
      className="Slot_form"
      onSubmit={masterFrom.handleSubmit}
      onReset={masterFrom.handleReset}
      autoComplete="off">
      <TextInputField
        id="fixture_id"
        name="fixture_id"
        label="Fixture "
        value={masterFrom.values.fixture_id}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.fixture_id && masterFrom.errors.fixture_id
        }
        error={
          masterFrom.touched.fixture_id && Boolean(masterFrom.errors.fixture_id)
        }
      />

      <TextInputField
        id="fixture_ip_address"
        name="fixture_ip_address"
        label="Fixture Ip Address "
        value={masterFrom.values.fixture_ip_address}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.fixture_ip_address &&
          masterFrom.errors.fixture_ip_address
        }
        error={
          masterFrom.touched.fixture_ip_address &&
          Boolean(masterFrom.errors.fixture_ip_address)
        }
      />

      <TextInputField
        id="aisle_id"
        name="aisle_id"
        label="Aisle ID"
        value={masterFrom.values.aisle_id}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.aisle_id && masterFrom.errors.aisle_id}
        error={masterFrom.touched.aisle_id && Boolean(masterFrom.errors.aisle_id)}
      />

      <TextInputField
        id="group_id"
        name="group_id"
        label="Group ID"
        value={masterFrom.values.group_id}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.group_id && masterFrom.errors.group_id}
        error={masterFrom.touched.group_id && Boolean(masterFrom.errors.group_id)}
      />

      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default SlotForm;

const initialValues = {
  // parking_type: "",
  // space_name: "",
  // zone_id: 0,
  // space_id: 0,
  // status: null
  aisle_id: '1',
  group_id: '1',
} as ISlotList;
